// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1B_Um","row":"styles_row__SO1yi"};